import { Component, OnInit, Input,Output , EventEmitter } from '@angular/core';
import {FormGroup} from '@angular/forms';
import{LoopBackAuth, matriculaService, validacionService} from '../../shared/services/api-rest.service';
import{MessageService} from '../../shared/services/message.service';

@Component({
  selector: 'aceptar-acuerdo-matricula',
  template: `
    <h4 style="color:#364a82" class="f-16">Compromiso padre de familia</h4>
    <div class="p-2 mt-2" style="color:#969696; background-color: #f2f2f2">
      <p class="text-center f-16">ACTA DE COMPROMISO ENTRE EL REPRESENTANTE LEGAL DE LA ESTUDIANTE Y LA UNIDAD EDUCATIVA PARTICULAR “FRAU KLIER”</p>
      <!--p class="text-justify">
        Como legítimo representante del estudiante, {{formMatriculaAlumno.get('alumno.apellido').value | uppercase}} {{formMatriculaAlumno.get('alumno.nombre').value | uppercase}}
        del (grado/curso)  {{curso}}, al matricular a mi representada en la
        Unidad Educativa Frau Klier, declaro con total libertad y sinceridad que conozco
        las disposiciones constantes en el documento publicado en la página WEB de la institución, normas que las he leído y
        comprendido en su totalidad,  por lo tanto me comprometo, a nombre de mi representada a observar y cumplir en su totalidad,
        durante todo el tiempo que ella permanezca como estudiante en esta institución educativa ,
      </p -->
      <p class="text-justify">
        El representante legal declara que la información registrada en las fichas de matrícula, formularios y documentos institucionales es verídica, completa, actualizada y entregada bajo su absoluta responsabilidad.
      </p>
      <p class="text-justify"> 
         Asimismo, se compromete a informar oportunamente cualquier modificación relacionada con datos personales, médicos, psicológicos, académicos, familiares, legales o de contacto del estudiante.
      </p>
      <p class="text-justify"> 
        El representante legal reconoce que la omisión, falsedad, alteración o entrega inexacta de información podrá afectar los procesos institucionales de seguimiento y protección integral del estudiante, así como generar las responsabilidades administrativas, civiles o legales correspondientes.
      </p>
      <p class="text-justify">
        La institución educativa utilizará la información proporcionada exclusivamente para fines académicos, administrativos y de protección estudiantil, conforme a la Constitución de la República del Ecuador, la Ley Orgánica de Educación Intercultural (LOEI), la Ley Orgánica de Protección de Datos Personales y demás normativa vigente.
      </p>
  
    </div>
    <h4 style="color:#364a82" class="f-16 mt-2">Aceptación compromiso</h4>
    <div class="p-2 mt-2" style="color:#969696; background-color: #f2f2f2">
      <p><strong>{{fechaActual | date:'MMMM d, y'}}</strong></p>
      <p>DECLARACIÓN DE ACEPTACIÓN</p>
      <div class="border-checkbox-section">
        <div class="border-checkbox-group border-checkbox-group-primary">
          <input
            class="border-checkbox"
            type="checkbox"
            [(ngModel)]="aceptarAcuerdo"
            (change)="emitAceptarAcuerdo.emit(aceptarAcuerdo)"
            [disabled]="formMatriculaAlumno.get('glbEstado').value > 101"
            [checked]= "aceptarAcuerdo || formMatriculaAlumno.get('glbEstado').value > 101"
            id="aceptarAcuerdo">
          <label
            class="border-checkbox-label"
            for="aceptarAcuerdo">
             Declaro que he leído, comprendido y acepto la responsabilidad sobre la veracidad, actualización y entrega correcta de la información proporcionada durante el proceso de matrícula institucional.
             La selección de esta opción constituye aceptación y conformidad para la finalización del proceso de matrícula.</label>
        </div>
      </div>
    </div>
  `,
  providers:[LoopBackAuth, matriculaService, validacionService, MessageService]
})
export class AceptarAcuerdoMatriculaComponent implements OnInit {
  @Input() formMatriculaAlumno : FormGroup
  @Output() emitAceptarAcuerdo  = new EventEmitter()
  public aceptarAcuerdo: boolean = false
  public periodo: string
  public curso :String
  public fechaActual = new Date(Date.now())

  constructor(
    private matriculaService:matriculaService,
    private LoopBackAuth:LoopBackAuth,
    public val: validacionService
  ) { }

  ngOnInit() {
    this.periodo = this.LoopBackAuth.load().acaPerido
    this.matriculaService.listasCursos('nivel',0).subscribe(
      result=>{
          this.curso = this.val.buscarDescripcion(result, this.formMatriculaAlumno.get('curso.nivel').value)
      }
  )
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/fichaEstudiante/aceptar-acuerdo-matricula.component.ts